import React from 'react';
export default function Operation({ color = '#E63E3D' }) {
  return (
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 50 50"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g stroke={color} strokeWidth="3">
          <g transform="translate(5.000000, 7.000000)">
            <path d="M4,2.5 C2.61928813,2.5 1.5,3.61928813 1.5,5 L1.5,26 C1.5,27.3807119 2.61928813,28.5 4,28.5 L36,28.5 C37.3807119,28.5 38.5,27.3807119 38.5,26 L38.5,5 C38.5,3.61928813 37.3807119,2.5 36,2.5 L4,2.5 Z" />
            <path
              d="M8.33326764,11.3056518 L19.3332676,11.3056518 C19.8855524,11.3056518 20.3332676,11.753367 20.3332676,12.3056518 L20.3332676,18.3610369 C20.3332676,18.9133216 20.7809829,19.3610369 21.3332676,19.3610369 L32.333421,19.3610369"
              strokeLinecap="round"
              transform="translate(20.333344, 15.333344) rotate(-45.000000) translate(-20.333344, -15.333344) "
            />
            <path d="M20,0 L20,2" strokeLinecap="round" />
            <g transform="translate(10.000000, 30.000000)" strokeLinecap="round">
              <path d="M10,0 L10,2" />
              <polyline points="0 7 10 3 20 7" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
